import ServerAPI from '@/apis/server';
import CourseBook from '@/apis/books/course.json';

const fetchCourses = ({ type }) => {
  return ServerAPI.get(`${CourseBook.REST}/${type}`);
};

export { fetchCourses };
